"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function GmailGreyMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M1.26 13.904h2.483v-6.03L.195 5.213v7.63c0 .585.476 1.06 1.066 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M12.258 13.904h2.482c.589 0 1.065-.476 1.065-1.066V5.213l-3.547 2.661v6.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M12.258 3.262v4.612l3.547-2.661V3.796c0-1.315-1.502-2.068-2.556-1.276l-.991.742z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    fillRule: "evenodd",
    d: "M3.743 7.874V3.262L8 6.454l4.258-3.192v4.612L8 11.067 3.743 7.874z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M.195 3.796v1.42l3.548 2.662V3.262l-.992-.746C1.698 1.728.195 2.481.195 3.796z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M3.938 14.099H1.26A1.26 1.26 0 010 12.842v-8.02l3.938 2.955v6.322zM.39 5.603v7.235c0 .484.39.87.87.87h2.287V7.973L.39 5.603zM14.74 14.099h-2.678V7.777L16 4.823v8.015a1.26 1.26 0 01-1.26 1.26zm-2.287-.39h2.287c.48 0 .87-.39.87-.87V5.602l-3.157 2.369v5.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M12.062 8.265v-5.1l1.074-.805a1.777 1.777 0 011.877-.167c.608.304.987.92.987 1.603v1.518l-3.938 2.95zm.39-4.906v4.125l3.158-2.369V3.796c0-.542-.29-1.01-.773-1.252a1.38 1.38 0 00-1.467.132l-.917.683z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8 11.312l-4.453-3.34v-5.1L8 6.211l4.453-3.34v5.1L8 11.312zM3.938 7.777L8 10.825l4.063-3.048V3.652L8 6.7 3.938 3.652v4.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M3.938 8.265L0 5.31V3.796c0-.682.379-1.295.991-1.603a1.787 1.787 0 011.877.167l1.073.804v5.1h-.003zM.39 5.115l3.157 2.37V3.358l-.913-.686a1.387 1.387 0 00-1.471-.133A1.384 1.384 0 00.39 3.796v1.32z"
  }));
}

GmailGreyMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
GmailGreyMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = GmailGreyMultitoneFilled;
exports["default"] = _default;